<section class="accordion col-lg-8">
  <h2 class="accordion__title">{{ accordion().title }}</h2>
  <div class="accordion__description">{{ accordion().description }}</div>
  <ul class="accordion__list">
    @for (item of accordion().accordionItems; track item.question) {
      <li class="accordion__list-item">
        <details
          class="accordion__item"
          trackInteraction="click"
          interactionCategory="accordion"
          [interactionData]="{ subject: 'accordion', name: item.question }"
        >
          <summary class="accordion__item-question">
            <h3 class="accordion__item-heading">
              {{ item.question }}
            </h3>
          </summary>
          <div class="accordion__item-answer">
            <wl-rich-text-wrapper [field]="{ value: item.answer }">
              <div class="table-responsive"></div
            ></wl-rich-text-wrapper>

            @if (feedbackSettings()) {
              <wl-accordion-feedback
                [question]="item.question"
                [feedbackSettings]="feedbackSettings()!"
              />
            }
          </div>
        </details>
      </li>
    }
  </ul>
</section>
